import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom'; // Import 'Routes' here
import './App.css';
import Home from './components/Home';

function App() {
  return (
    <Router>
      <div className="App">        
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
